var map = {
	"./customer-bg.webp": 1449,
	"./customer-img.webp": 1450,
	"./dice-img.webp": 1451,
	"./games-img.webp": 1452,
	"./lc-img.webp": 1453,
	"./lottery-img.webp": 1454,
	"./mission-bg.webp": 1455,
	"./mission-img-2.webp": 1456,
	"./mission-img.webp": 1457,
	"./mission-main-bg.webp": 1458,
	"./mobile-bg.webp": 1459,
	"./p2p-img.webp": 1460,
	"./product-bg.webp": 1461,
	"./product-main-bg.webp": 1462,
	"./sb-provider.webp": 1463,
	"./sbo-provider.webp": 1464,
	"./side-bar-bg.webp": 1465,
	"./slot-img.webp": 1466,
	"./spade-img.webp": 1467,
	"./sport-img.webp": 1468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 205;